// extracted by mini-css-extract-plugin
export default {"wrap":"InitTest_wrap__fXjkT","container":"InitTest_container__7gssj","question":"InitTest_question__elmZS","delay":"InitTest_delay__hZKkt"};